module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_5012.dafe97c6.png";